package com.siriusxm.cmc.utils

/**
 * Log an info message
 */
public fun logInfo(message: String) {
    println(message)
}